import { setAgrEnvironment } from '@next/core-lib/environment';

import { Environment } from 'src/environments/environment.model';

export const parseGrainRegistrationEnvironment = (config: Record<string, string>): Environment => ({
  ...setAgrEnvironment(config),
  MAINTENANCE_MODE: config.MAINTENANCE_MODE?.toLowerCase() === 'true',
});
